import { ChatRepository } from "../../domain/repositories/ChatRepository";
import { ChatDataSource } from "../datasource/ChatDataSource";
import { AppConstants } from "../../../../core/constants/constants";
import { Chats } from "../../domain/entities/getChat";
import { ChatMessage } from "../../domain/entities/getMessages";
import { ChatMessageParams } from "../../domain/entities/getMessagesParams";
import { UploadFileProps } from "../../domain/entities/uploadFile";

export class ChatRepositoryImpl implements ChatRepository {
	constructor(private dataSource: ChatDataSource) {}
	getChats(): Promise<Chats[]> {
		return AppConstants.getRightOrLeftSide<Chats[]>(this.dataSource.getChats());
	}
	getMessages(data: ChatMessageParams): Promise<ChatMessage[]> {
		return AppConstants.getRightOrLeftSide<ChatMessage[]>(this.dataSource.getMessages(data));
	}
	clearChat(chat_id: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(this.dataSource.clearChat(chat_id));
	}
	uploadFile(params: UploadFileProps): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(this.dataSource.uploadFile(params));
	}
}
